import { render, staticRenderFns } from "./DocumentTypesPage.vue?vue&type=template&id=7b12d13a&scoped=true"
import script from "./DocumentTypesPage.vue?vue&type=script&lang=js"
export * from "./DocumentTypesPage.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypesPage.vue?vue&type=style&index=0&id=7b12d13a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b12d13a",
  null
  
)

export default component.exports